import {getXAxis} from "@/assets/js/get-xaxis";

export const getOzonAmzConfig = (data) => {
	const xAxis = getXAxis()
	const width = document.body.clientWidth
	let is_w = width / 1920;is_w=is_w>1?1:is_w
	const yAxis = [

			{
				name: '交易额               ',
				data: 'value',
				min: 0,
				max: 200,
				interval: 40,
				axisLine: {
					style: {
						stroke: 'rgba(0,0,0,0)',
						lineWidth: 1
					}
				},
				splitLine: {
					style:{
						stroke: 'rgba(255,255,255,0.3)',
					}
				},
				axisLabel: {
					formatter: '{value} 万元',
					style: {
						fill: '#cdcac3',
						fontSize:is_w*18
					}
				},
				nameTextStyle: {
					fill: '#fff',
					fontSize:is_w*18
				},
				axisTick: {
					show: false
				}
			}

		]
	let max = 0

	const series = [
		{
			name: 'Amazon',
			data: [


			],
			type: 'line',
			lineStyle: {
				stroke: '#e8c072',
				lineWidth: 2
			},
			linePoint: {
				style: {
					stroke: '#f19745'
				}
			},
			smooth: true,
			lineArea: {
				show: true,
				gradient: ['#e4ac3e', 'rgba(247,191,80,0)']
			},
			animationCurve: 'easeOutBounce'
		},
		{
			name: 'Ozon',
			data: [


			],
			smooth: true,
			type: 'line',
			lineArea: {
				show: true,
				gradient: ['rgba(251, 244, 247, 1)', 'rgba(251, 214, 247, 0)']
			},
			lineStyle: {
				stroke: '#fff',
				lineWidth: 2
			},
			linePoint: {
				style: {
					stroke: '#f19745'
				}
			},

			animationCurve: 'easeOutBounce'
		},

	]
	xAxis.data.forEach(date => {
		const item = data.find(item => item.date === date)
		if (item) {
			let amazon_order_amount = item.amazon_order_amount / 10000
			if (amazon_order_amount > max) {
				max = amazon_order_amount
			}

			let ozon_order_amount = item.ozon_order_amount/10000
			if (ozon_order_amount > max) {
				max = ozon_order_amount
			}
			series[0].data.push(amazon_order_amount)
			series[1].data.push(ozon_order_amount)
		} else {
			series[0].data.push(0)
			series[1].data.push(0)
		}
	})
	yAxis[0].max = Math.ceil(max)
	yAxis[0].interval = yAxis[0].max / 4

	return {xAxis, series, yAxis}
}
